<template lang="pug">
span.reqirements
    template(v-for="(req, index) in requirementsLocalized")
        a(:href="req.url" target="_blank" rel="noopener noreferrer") {{ req.link_label }}
        template(v-if="index + 1 !== requirements.length")
            | ,
            |
</template>
<script>
export default {
    name: 'Requirements',

    props: {
        requirements: {
            type: Array,
            required: true
        }
    },

    computed: {
        requirementsLocalized () {
            const locale = this.$i18n.locale;

            if (!locale) return this.requirements;

            return this.requirements.map(req => {
                const localizedVersion = req.i18n?.[locale];
                if (localizedVersion) {
                    return localizedVersion;
                }
                return req;
            });
        },
    },
}
</script>
